module.exports = __webpack_public_path__ + "media/images/photos/headlight-16832a5f385c0a78016f6240c24f277f.jpg";